import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DnnContextService } from "./Dnn/dnncontext.service";

@Injectable({
    providedIn: 'root'
})
export class MensajeServices {
    private _urlBase: string;

    constructor(private ctx: DnnContextService) {
        this._urlBase = this.ctx.properties.ModuleDirectory + 'wwwroot/assets/config/';
    }    

    async CargarMensajes() {
        var raw = await fetch(this._urlBase + 'Mensajes.json');
        return raw.json();
    }
}